import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { DocumentCourseFilter } from "./DocumentCourseFilter";

interface DocumentFilterProps {
  selectedCourseIds: string[];
  onCourseFilterChange: (courseIds: string[]) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
}

export const DocumentFilter = ({
  selectedCourseIds,
  onCourseFilterChange,
  searchQuery,
  onSearchChange,
  onSearchFocus,
  onSearchBlur,
}: DocumentFilterProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={onSearchFocus}
          onBlur={onSearchBlur}
          className="pl-9"
          autoComplete="off"
        />
      </div>
      <DocumentCourseFilter
        selectedCourseIds={selectedCourseIds}
        onCourseFilterChange={onCourseFilterChange}
      />
    </div>
  );
};
